export const UPDATE_PIXELS = "updatePixels";
export function updatePixels(newPixels) {
	return {
		type: UPDATE_PIXELS,
		payload: newPixels,
	};
}
